var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRec2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 68,
    viewBox: "0 0 223 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.968845,
    y: 0.821675,
    width: 219.907,
    height: 55.2829,
    rx: 27.6414,
    transform: "matrix(0.99785 -0.0655422 0.0982707 0.99516 -1.92632 12.8722)",
    fill: "#FE3D4D",
    stroke: "white",
    strokeWidth: 1.76777,
    strokeDasharray: "5.89 5.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRec2);
export default __webpack_public_path__ + "static/media/rec2.3090e7cb3985c37322dbf0e53431876b.svg";
export { ForwardRef as ReactComponent };